import { render, staticRenderFns } from "./PipelineDataTable.vue?vue&type=template&id=8163c446"
import script from "./PipelineDataTable.vue?vue&type=script&lang=js"
export * from "./PipelineDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports